import { createSlice } from '@reduxjs/toolkit';
import {
  addTokenReducer,
  getTokensReducer,
  loginReducer,
  logoutReducer,
  restoreSessionReducer,
} from './user.reducers';
import { UserState } from './user.types';

export const initialState: UserState = {
  loading: 'idle',
  authenticated: false,
  error: { name: '', message: '' },
  login: null,
  role: null,
  userData: null,
  authTokens: null,
  token: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    sessionExpired: state => {
      state.authenticated = false;
      state.role = null;
      state.login = null;
      state.userData = null;
      state.token = null;
    },
  },
  extraReducers: builder => {
    getTokensReducer(builder);
    addTokenReducer(builder);
    loginReducer(builder);
    restoreSessionReducer(builder);
    logoutReducer(builder);
  },
});

export const { sessionExpired } = userSlice.actions;

export default userSlice.reducer;
